<template>
  <div ref="serviceAddressBox" class="service-address-box">

    <div class="service-address-content">
      <div class="title">
        京东服务
      </div>
      <div class="address" @click="onClickDeliveryAddressShow">
        <div class="address-icon"></div>
        <div class="address-content">{{defaultAddress.fullAddress}}</div>
      </div>
    </div>
    <div class="service-address-base">

    </div>

  </div>
</template>

<script>
export default {
  name: 'ServiceAddressBox',
  components: {},
  data() {
    return {};
  },
  props: {
    defaultAddress: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  computed: {},
  created() {},
  methods: {
    onClickDeliveryAddressShow() {
      this.$emit('onClickDeliveryAddressShow');
    }
  },
  mounted() {},
  destroyed() {
    this.$refs = null;
    this._self = null;
  }
};
</script>

<style lang="scss">
@import '@/scss/mixin.scss';
.service-address-box {
  .service-address-content {
    width: 100%;

    padding: $rem30 0 $rem30 $rem24;
    .title {
      font-family: PingFangSC-Medium;
      font-size: $rem32;
      line-height: $rem32;
      color: #222222;
      letter-spacing: 0;
      line-height: 32px;
      margin-bottom: $rem30;
    }
    .address {
      padding-right: $rem50;
      display: flex;
      flex-direction: row;
      justify-content: flex-start;
      .address-icon {
        width: $rem32;
        height: $rem32;
        margin-right: $rem8;
        background-image: url('http://img12.360buyimg.com/jrpmobile/jfs/t27226/106/1447017089/1279/e932e426/5be3e907Nfb485025.png');
        background-repeat: no-repeat;
        background-position: 0 0;
        background-size: 100% 100%;
        content: '';
      }
      .address-content {
        flex: 1;
        font-family: PingFangSC-Regular;
        font-size: $rem28;
        color: #c29451;
        letter-spacing: 0;
        line-height: $rem32;
      }
    }
  }
  .service-address-base {
    width: 100%;
    background: #f7f7f7;
    height: $rem20;
  }
}
</style>
